document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".multicolumn_slider:not(.disable_slider)")
    .forEach(function (slider) {
      const gap = slider.getAttribute("data-multicomumngap") || 10;
      console.log(gap);
      const mySwiper = new Swiper(slider, {
        roundLengths: true,
        loop: false,
        pagination: {
          el: slider
            .closest(".multicolumn-section")
            .querySelector(".multicomn_pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: slider
            .closest(".multicolumn-section")
            .querySelector(".multicomn_next"),
          prevEl: slider
            .closest(".multicolumn-section")
            .querySelector(".multicomn_prev"),
        },
        breakpoints: {
          0: {
            slidesPerView: 1.25,
            spaceBetween: 10,
          },
          749: {
            slidesPerView: 1.2,
            spaceBetween: 10,
          },
          750: {
            slidesPerView: 2.1,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: gap,
          },
        },
      });
    });
});

let recommend = document.querySelector(".js-recommendation-swiper");
if (recommend) {
  const initSlider = () => {
    let mobileLayout = 1.25;
    if (recommend.dataset.mobileLayout) {
      mobileLayout = recommend.dataset.mobileLayout;
    }
    let slider = new Swiper(recommend, {
      slidesPerView: mobileLayout,
      slidesPerGroup: 1,
      spaceBetween: 8,
      speed: 500,
      pagination: {
        el: ".recommendations_pagination",
        clickable: true,
      },
      navigation: {
        nextEl: document.querySelector(
          ".product-recommendations__slider-nav .swiper-button-next"
        ),
        prevEl: document.querySelector(
          ".product-recommendations__slider-nav .swiper-button-prev"
        ),
      },
      breakpoints: {
        576: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        750: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 24,
        },
      },
    });
  };
  initSlider()
}
window.addEventListener('beforeunload', function (event) {
  console.log('Window is about to be reloaded or closed.');
  sessionStorage.setItem('cartNote', "");
});
function storeTextareaValue() {
const textarea = document.querySelector('#CartDrawer textarea#Cart-note');
  if (textarea) {
    textarea.addEventListener('input', () => {
      sessionStorage.setItem('cartNote', textarea.value);
    });
  }
}
  function restoreTextareaValue() {
    const textarea = document.querySelector('#CartDrawer textarea#Cart-note');
  
    if (textarea) {
      const storedValue = sessionStorage.getItem('cartNote');
      if (storedValue) {
        textarea.value = storedValue;
      }
    }
  }
storeTextareaValue()
restoreTextareaValue()

document.addEventListener('updateCartnote', function(event) {
  storeTextareaValue()
  restoreTextareaValue()
});


